<template>
  <div style="margin-bottom: 24px">
    <el-row :gutter="24">
      <el-col :span="12">
        <el-row class="status_section">
          <p class="status_section-title">Cтатус договора:</p>
        </el-row>
        <el-row>
          <div class="status_section">
            <span
              v-if="isActualAndDownload"
              type="success"
              class="status_section-item green"
            >
              <img class="status_section-img" src="@/assets/img/signed.svg" />
              Назначен актуальный
            </span>
            <span v-else type="danger" class="status_section-item red">
              <img class="status_section-img" src="@/assets/img/minus.svg" />
              Актуальный договор не назначен
            </span>
            <span
              v-if="isSignedAndDownload"
              type="warning"
              class="status_section-item green"
            >
              <img class="status_section-img" src="@/assets/img/pen.svg" />
              Договор подписан
            </span>
            <span v-else style="display: flex; justify-content: center">
              <span v-if="!isDownload" class="status_section-item red">
                <img class="status_section-img" src="@/assets/img/minus.svg" />
                Договор отсутствует
              </span>
              <span v-if="isDownload" class="status_section-item orange">
                <img
                  class="status_section-img-file"
                  src="@/assets/img/file_new.svg"
                />
                Договор загружен
              </span>
            </span>
          </div>
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-row class="status_section">
          <p class="status_section-title">Последнее обновление:</p>
        </el-row>
        <el-row>
          <span>
            {{ getActualDate }}
          </span>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'StatusList',
  props: {
    isActualAndDownload: {
      type: Boolean,
      require: true,
    },
    isSignedAndDownload: {
      type: Boolean,
      require: true,
    },
    isSigned: {
      type: Boolean,
      require: true,
    },
    isDownload: {
      type: Boolean,
      require: true,
    },
    getActualDate: {
      type: String,
      require: true,
    },
  },
}
</script>

<style lang="sass">
.status_section
  display: flex
  align-items: center
  justify-content: flex-start
  flex-wrap: wrap
  &-title
    display: block
    font-size: 16px
    color: #606266
    margin: 0
  &-item
    display: flex
    align-items: center
    justify-content: center
    margin-right: 6px
  &-img
    width: 18px
    margin-right: 4px
  &-img-file
    width: 13px
    margin-right: 4px
  .green
    color: #67c23a
  .red
    color: #f56c6c
  .orange
    color: #e6a23c
</style>
